export default (firstName = '', lastName = '') => {
  return [firstName, lastName]
    .filter(Boolean)
    .map(name => name[0])
    .join('');
};
